import { administrationRequests } from "api/administrationApi";
import React from "react";
import { ReferenceInput, required as raReq, SelectInput } from "react-admin";

const StructuralUnitsInput = ({
  alwaysOn = false,
  fullWidth = false,
  required = false,
  filterByUser = false,
  source,
}) => {
  const validations = [required ? raReq() : []];

  return (
    <ReferenceInput
      source={source}
      alwaysOn={alwaysOn}
      label="Структурна единица"
      reference={administrationRequests.getStructuralUnitsSelect()}
      filter={{ filterByUser: filterByUser ? true : false }}
    >
      <SelectInput
        fullWidth={fullWidth}
        label="Структурна единица"
        validate={validations}
      />
    </ReferenceInput>
  );
};

export default StructuralUnitsInput;
